import { Dropdown, Modal, PrimaryButton } from "@fluentui/react";
import React, { useEffect, useState, useContext } from "react";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import ModalMain from "../../../../../components/Modal/ModalMain";
import ModalFooter from "../../../../../components/Modal/ModalFooter";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import { getPacsNodeForSending, pullPacsStudyReport, sendToNodes } from "../../../../../service/StudyListService";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import themeContext from "../../../../../context/theme/ThemeContext";
import loaderContext from "../../../../../context/loader/LoaderContext";
import toastContext from "../../../../../context/toast/ToastContext";
import { TOAST_TYPE } from "../../../../../constants/Constants";
import SearchableDropDown from "../../../../ReportTemplates/helper/SearchDropdown";
import OutsideClickHandler from 'react-outside-click-handler';
import './SendToPACSModal.css'

const SendToPACS = (props) => {
  const [loading, setLoading] = useState(false);
  const { ref, setLoaderRunning, showModal, setShowModal } = useContext(loaderContext);
  const [nodeList, setNodeList] = useState([]);
  const [selectedNodeIds, setSelectedNodeIds] = useState([]);
  const [responseMessage, setResponseMessage] = useState("");
  const [t] = useTranslation();
  const { showToastv2 } = useContext(toastContext);
  const [nodeFilteredItems, setNodeFilteredItems] = useState(nodeList);

  let PrimaryButtonList = [
    {
      title: t("button.close"),
      onclick: () => props.setShowSendToPacsModal(false),
    },
  ];

  const getNodesForSending = async() =>{
    setLoading(true);
    const response = await getPacsNodeForSending(props.studyId);
    console.log("Get information from pacs response :", response)
    if (response.status == 200 && response.data.result == "SUCCESS") {
      if(response.data.data != null && response.data.data != undefined && response.data.data.length > 0){
        let nodeListItem = [];
        response.data.data.map((node) => {
          nodeListItem.push({
            key: node.id,
            text: node.name,
          });
        });
        setNodeList(nodeListItem);
        setNodeFilteredItems(nodeListItem);
      }else{
        setResponseMessage("No PACS available!");
      }
      
      setLoading(false);
    } else {
      setLoading(false);
    }
    
  }

  const handleDropdownChange = (event, item) => {
    if (item) {
      const updatedSelectedNodeIds = item.selected
        ? [...selectedNodeIds, item.key]
        : selectedNodeIds.filter(id => id !== item.key);
      setSelectedNodeIds(updatedSelectedNodeIds);
    }
    setNodeFilteredItems(nodeList)
  };

  const handleSendToNodes = async() =>{
    console.log("sending to Nodes", selectedNodeIds);
    if(selectedNodeIds.length == 0){
      showToastv2(TOAST_TYPE.INFO, "Select atleast one PACS!");
      return;
    }
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await sendToNodes(props.studyId, selectedNodeIds);
    console.log("Send to pacs response :", response)
    if(response.data.result === "SUCCESS"){
      showToastv2(TOAST_TYPE.SUCCESS, response.data.message);
    }else{
      showToastv2(TOAST_TYPE.ERROR, "Some error occurred in sent to PACS!");
    }
    setLoaderRunning(false);
    ref.current.complete();
  }

  useEffect(() => {
    getNodesForSending();
  }, []);

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={`${t("study-list.actions.send-to-pacs")}`}
        handleCancel={() => props.setShowSendToPacsModal(false)}
      />
    ),
    body: (
      <SendToPACSModal
        nodeList={nodeList}
        responseMessage={responseMessage}
        loading={loading}
        setShowSendToPacsModal={props.setShowSendToPacsModal}
        handleDropdownChange={handleDropdownChange}
        selectedNodeIds={selectedNodeIds}
        setSelectedNodeIds={setSelectedNodeIds}
        handleSendToNodes={handleSendToNodes}
        nodeFilteredItems={nodeFilteredItems}
        setNodeFilteredItems={setNodeFilteredItems}
      />
    ),
    footer: (
      <ModalFooter
        PrimaryButtonList={[]}
        DefaultButtonList={PrimaryButtonList}
      />
    ),
    width: "785px",
  };

  return (
    <>
      <ModalMain
        updatedModal = {true}
        modalDetails={modalDetails}
        showModal={props.showSendToPacsModal}
      />
    </>
  );
};

export default SendToPACS;

export const SendToPACSModal = (props) => {
  const [t] = useTranslation();
  const { getThemeColor } = useContext(themeContext);

  const dropDownStyle = {
    dropdown: {
      width: "100%"
    },
    dropdownItemSelected: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    dropdownItemsWrapper: {
      maxHeight: "300px",
      overflowY: 'auto',
    },
    dropdownItem: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
      color: "white"
    },
  };

  const noReason = {
    padding: "10px",
    textAlign: "center",
    color: getThemeColor("primary-color"),
  };

  const customSpinnerStyle = {
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };

  const sendNodeStyle = {
    height: "34px",
    margin: "0",
    marginBottom: "25px",
    display:"flex",
    width:"100%",
    alignItems: "center",
    justifyContent: "space-between",
  };

  console.log("pacs information :", props.nodeList)
  // let nodeList = [];
  // props.nodeList.map((modality) => {
  //   nodeList.push({
  //     key: modality.id,
  //     text: modality.name,
  //   });
  // });


  const handleClickOutside = () => {
    props.setNodeFilteredItems(props.nodeList)
  };

  const onDropDownSearch = (
    searchValue,
    initialValues
  ) => {
    if (searchValue == null || searchValue == "") {
      return [...initialValues];
    }
    const filteredOptions = [...initialValues].filter(
      (i) => {
        let text = i.text.toLowerCase();
        return text.includes(searchValue.toLowerCase());
      }
    );


    return filteredOptions;
  }

  
  return (
    <>
      {props.loading ? (
        <Spinner size={SpinnerSize.small} styles={customSpinnerStyle} />
      ) : (
        <div className="upload-study-modal-container">
          <div className="container-content">
            {props.nodeList.length !== 0 ? (
              <>
                <div style={sendNodeStyle}>
                  <div className="ms-sm12 ms-md8 ms-lg6 ms-xl6">
                    <OutsideClickHandler onOutsideClick={handleClickOutside}>
                      <SearchableDropDown
                        dropDownStyle={dropDownStyle}
                        selectedKeys={props.selectedNodeIds}
                        onChange={props.handleDropdownChange}
                        onSearchValueChanged={(searchValue) => {
                          console.log("search value ", searchValue);
                          const newOptions = onDropDownSearch(
                            searchValue,
                            props.nodeList
                          );
                          props.setNodeFilteredItems(newOptions);
                        }}
                        options={
                          props.nodeFilteredItems.length > 0
                            ? props.nodeFilteredItems
                            : []
                        }
                        name="pacs node list"
                        className="form-field ms-Grid-col custom-pacs-node-dropdown modal-scroll"
                        style={{ width: "100%" }}
                        label=""
                        placeholder="Select PACS"
                        isMultiSelect={true}
                        isRequired={false}
                      />
                    </OutsideClickHandler>
                  </div>
                  <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2">
                    <PrimaryButton onClick={props.handleSendToNodes}>
                      Send
                    </PrimaryButton>
                  </div>
                </div>
              </>
            ) : (
              <p style={noReason}>{props.responseMessage}</p>
            )}
          </div>
        </div>
      )}
    </>
  );
};
